import React, { memo, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import PodPor from './PodPol';
import { Dialog, FlatButton, RaisedButton } from 'material-ui';
import _ from 'lodash';
import DateRangeSelector from 'components/Base/DateRangeSelector';
import moment from 'moment';
import { ContextDispatchHireOrders } from '../LetterHire';

const PodPorsBlock = ({ order, orderIndex }) => {
    const [openDialogs, setOpenDialogs] = useState({});
    /** @type {import('../hireOrdersReducer').TDispatchHireOrders} */
    const dispatchHireOrders = useContext(ContextDispatchHireOrders);

    const changePortData = (type, port) => {
        const _order = _.cloneDeep(order);
        _order[type] = port;
        dispatchHireOrders({ 
            type: 'UPDATE_ORDER', 
            payload: { index: orderIndex, value: _order },
        });
    };

    const handleToggleLayCanDialog = () => {
        setOpenDialogs({
            ...openDialogs,
            laycan: !openDialogs.laycan,
        });
    };

    const changeLayCan = (dates) => {
        const _order = _.cloneDeep(order);
        const { lay, can } = dates;
        _order.lay = lay;
        _order.can = can;
        dispatchHireOrders({ 
            type: 'UPDATE_ORDER', 
            payload: { index: orderIndex, value: _order },
        });
    };

    const actions = [
        <FlatButton
            label="Ok"
            primary
            onClick={() => {
                handleToggleLayCanDialog();
            }}
        />,
    ];

    return (
        <div>
            <div style={{ width: '97%', marginLeft: '10px' }}>
                <div className='row' style={{ background: '#EEF8E4' }}>
                    <div className='column-left'>
                        {'Port of delivery'}
                    </div>
                </div>
                <div className='row' style={{ background: '#EEF8E4' }}>
                    <PodPor
                        port={order.delivery}
                        portType='delivery'
                        changePortData={changePortData}
                    />
                    <RaisedButton
                        labelStyle={{ fontSize: '10px' }}
                        style={{ height: '25px', margin: '35px 0 0 23px' }}
                        buttonStyle={{ height: '25px', lineHeight: '25px' }}
                        label='Laycan'
                        onClick={() => handleToggleLayCanDialog()}
                        primary
                    />
                    <span style={{ fontSize: '12px', fontWeight: 'bold', margin: '40px 0 0 5px' }}>
                        {moment(order.lay).utc().format('DD-MM-YYYY')} --- {moment(order.can).utc().format('DD-MM-YYYY')}
                    </span>
                </div>
                <Dialog
                    title="Dialog With Date Picker"
                    actions={actions}
                    modal={false}
                    open={!!openDialogs.laycan}
                    onRequestClose={() => handleToggleLayCanDialog()}
                >
                    <DateRangeSelector
                        from={moment(order.lay).utc().toDate()}
                        until={moment(order.can).utc().toDate()}
                        fromLabel="Readiness date"
                        untilLabel="Cancelling date"
                        onChange={range => changeLayCan({ lay: range.from, can: range.until })}
                    />
                </Dialog>
                <br />
            </div>
            {/* Redelivery Ports Section */}
            <div style={{ width: '97%', marginLeft: '10px' }}>
                <div className='row' style={{ background: '#E8F0F8' }}>
                    <div className='column-left'>
                        {'Port of redelivery '}
                    </div>
                </div>
                <div className='row' style={{ background: '#E8F0F8' }}>
                    <PodPor
                        port={order.redelivery}
                        portType='redelivery'
                        changePortData={changePortData}
                    />
                </div>
                <br />
            </div>
        </div>
    );
};

PodPorsBlock.propTypes = {
    order: PropTypes.object.isRequired,
    orderIndex: PropTypes.number.isRequired,
};

export default memo(PodPorsBlock);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Hire/podPol/PodPorsBlock.jsx